/**
 * Single Cache Storage name for Vercel blob assets (see `public/blob-cache-name.js` + `public/sw.js`).
 * Do not add version suffixes here — legacy `eclipsera-assets-v1` / `-v2` are removed on SW activate.
 */
export const ECLIPSERA_BLOB_CACHE_STORAGE_NAME = 'eclipsera-assets' as const

/**
 * Same-origin static/game assets cached by `public/sw.js`. MUST equal `SHELL_CACHE_NAME` there.
 *
 * This is not cosmetic: `auditBlobWarmCache` reads this cache by name to decide whether a warmed
 * area can be skipped. A stale name opens an empty cache rather than failing, so every same-origin
 * asset audits as missing and the loading screen re-runs on every visit — which is exactly what a
 * drift to `-v6` (a name the worker deletes on activate) did to the world-map, PvE and MvM gates.
 */
export const ECLIPSERA_SHELL_CACHE_STORAGE_NAME = 'eclipsera-shell-v8' as const
